import {
    Home,
    Comparison,
    Logout,
    Archive,
    Calculator,
    Document,
    EquipmentCatalog,
} from "../../assets/icons";

export const topTooltipIcons = {
    admin: [
        { id: 1, icon: <Home />, tooltipText: "Dashboard", link: "/dashboard" },
        {
            id: 2,
            icon: <Calculator />,
            tooltipText: "ESP sizing guide",
            link: "/help",
        },
        {
            id: 3, icon: <Comparison />, tooltipText: "Submit a ticket", link: '_blank', handleClick: () => {
                window.open(`${process.env.REACT_APP_SUPPORT_URL}`, "_blank")
            }
        },
        { id: 4, icon: <Document />, tooltipText: "Documents", link: "/documents" },
        { id: 5, icon: <EquipmentCatalog />, tooltipText: "Equipment catalog", link: "/equipment-catalog" },
    ],
    nonAdmin: [
        { id: 1, icon: <Home />, tooltipText: "Dashboard", link: "/dashboard" },
        {
            id: 2,
            icon: <Calculator />,
            tooltipText: "ESP sizing guide",
            link: "/help",
        },
        {
            id: 3, icon: <Comparison />, tooltipText: "Submit a ticket", link: '_blank', handleClick: () => {
                window.open(`${process.env.REACT_APP_SUPPORT_URL}`, "_blank")
            }
        },
        { id: 4, icon: <Document />, tooltipText: "Documents", link: "/documents" },
    ],
    customer: [
        { id: 1, icon: <Home />, tooltipText: "Dashboard", link: "/dashboard" },
        {
            id: 2,
            icon: <Calculator />,
            tooltipText: "ESP sizing guide",
            link: "/help",
        },
        {
            id: 3, icon: <Comparison />, tooltipText: "Submit a ticket", link: '_blank', handleClick: () => {
                window.open(`${process.env.REACT_APP_SUPPORT_URL}`, "_blank")
            }
        },
        { id: 4, icon: <Document />, tooltipText: "Documents", link: "/documents" },
    ],
};

export const bottomTooltipIcons = {
    admin: [
        { id: 3, icon: <Logout />, tooltipText: "Logout", link: "/logout" },
    ],
    customer: [
        { id: 2, icon: <Logout />, tooltipText: "Logout", link: "/logout" },
    ],
};
